(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-allergietest"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-allergy-dog')) {
  customElements.define('gl-allergy-dog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyButton = this.querySelector('[data-sticky-add]');
      const stickyVariant = this.querySelector('[data-sticky-variant]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      observer.observe(button);
      this.stickyObserver = observer;

      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        stickyPrice.textContent = selected.dataset.money;
        stickyVariant.textContent = selected.dataset.title;

        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-barf"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-barf-dog')) {
  customElements.define('gl-barf-dog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-dna-rasse"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-dna-breed')) {
  customElements.define('gl-dna-breed', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyButton = this.querySelector('[data-sticky-add]');
      const stickyVariant = this.querySelector('[data-sticky-variant]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      observer.observe(button);
      this.stickyObserver = observer;

      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        stickyPrice.textContent = selected.dataset.money;
        stickyVariant.textContent = selected.dataset.title;

        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-erbkrankheiten"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-hereditary-dog')) {
  customElements.define('gl-hereditary-dog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-inhalation"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gl-inhalation-dog')) {
  customElements.define('gl-inhalation-dog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        button.disabled = selected.dataset.available !== 'true';
        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-mikrobiom-pro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => {
    const root = document.getElementById('gl-mikrobiom-pro');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const query = new URLSearchParams(window.location.search);
    const code = (query.get('discount') || query.get('discount_code') || '').toUpperCase();
    const campaign = query.get('utm_campaign') || '';
    const source = query.get('utm_source') || '';
    let referral = false;
    try { const ref = new URL(document.referrer); referral = ref.origin === window.location.origin && /\/discount\/MIKRO40/i.test(ref.pathname); } catch {}
    const invitation = code === 'MIKRO40' || referral || (/klaviyo/i.test(source) && /mikrobiom/i.test(campaign));
    const price = root.querySelector('[data-price]');
    const priceLabel = root.querySelector('.price-label');
    const standardPrice = price.textContent;
    const standardLabel = priceLabel.textContent;
    const update = () => {
      const now = Date.now();
      const active = invitation && root.dataset.offerEligible === 'true' && now >= Date.parse('2026-09-09T10:00:00Z') && now < Date.parse('2026-09-13T10:00:00Z');
      root.classList.toggle('gl-invitation', active);
      price.textContent = active ? root.dataset.offerPrice : standardPrice;
      priceLabel.textContent = active ? root.dataset.offerLabel : standardLabel;
    };
    update();
    window.addEventListener('pageshow', update);
    document.addEventListener('visibilitychange', update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-refresh-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => document.querySelectorAll('[data-gl-product]').forEach(root => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const price = root.querySelector('[data-gl-price]');
    const button = root.querySelector('[data-gl-add]');
    const variants = [...root.querySelectorAll('[data-gl-variant]')];
    const update = (input, changeUrl) => {
      if (!input) return;
      price.textContent = input.dataset.price;
      button.disabled = input.dataset.available !== 'true';
      button.textContent = button.disabled ? root.dataset.soldLabel : root.dataset.addLabel;
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState(window.history.state, '', url);
      }
    };
    variants.forEach(input => input.addEventListener('change', () => update(input, true)));
    const sync = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      const input = variants.find(item => item.value === id) || variants.find(item => item.checked);
      if (input) input.checked = true;
      update(input, false);
    };
    sync();
    window.addEventListener('pageshow', sync);
    window.addEventListener('popstate', sync);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
      theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
